import { BaseService } from "services/_baseService";
import appAxios from "services/axios";

class ChatsAdminService extends BaseService<any> {
  constructor() {
    super(`chats`);
  }

  // Получаем список чатов
  getChats = async (queryParams: object = {}) => {
    return appAxios.get(`${this.pathWithOrg()}`, { params: queryParams });
  };

  // Получаем сообщения по ID чата
  getMessagesByChatID = async (chatID: number, queryParams: object) => {
    return appAxios.get(`${this.pathWithOrg()}/${chatID}/messages`, { params: queryParams });
  };

  // Создаем чат
  create = async (data: any) => {
    return appAxios.post(`${this.pathWithOrg()}`, data);
  };

  // Сбросить зависшую автоматизацию (activeAutomationID + currentNodeID = null)
  resetAutomation = async (chatID: number) => {
    return appAxios.post(`${this.pathWithOrg()}/${chatID}/reset-automation`);
  };
}

export default new ChatsAdminService();
